import MetaModel from "../../../../Global/Models/Pagination/MetaModel";
import EventGamePredictionModel from "../Prediction/EventGamePredictionModel";

export default class EventGameRankingsModel {
  public meta: MetaModel = new MetaModel();
  public data: EventGamePredictionModel[] = [];
}
